import store from "@/store";
import { NavigationGuard } from "vue-router";

export const companyLoader: NavigationGuard = (to, from, next) => {
  store.dispatch("companyStore/resetStore");
  next();
};
